import { render, staticRenderFns } from "./sign-up-form.vue?vue&type=template&id=242914c0"
import script from "./sign-up-form.vue?vue&type=script&lang=js"
export * from "./sign-up-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports